import {
  AccordionContent,
  AccordionHeader,
  AccordionIcon,
  AccordionItem,
  AccordionTrigger,
} from "@repo/components/src/ui/accordion";
import { ChevronDownIcon, ChevronUpIcon } from "lucide-react-native";
import React, { ComponentProps } from "react";
import { Text } from "../../ui/text";

type Props = {
  title: string;
  titleProps?: ComponentProps<typeof Text>;
  value: string;
  children?: React.ReactNode;
  action?: React.ReactNode;
  accordionItemProps?: Omit<
    ComponentProps<typeof AccordionItem>,
    "value" | "children"
  >;
};

const SimpleAccordionItem = React.memo((props: Props) => {
  return (
    <AccordionItem value={props.value} {...props.accordionItemProps}>
      <AccordionHeader>
        <AccordionTrigger>
          {({ isExpanded }) => {
            return (
              <>
                <Text size="sm" {...props.titleProps}>
                  {props.title}
                </Text>
                {props.action}
                {isExpanded ? (
                  <AccordionIcon as={ChevronUpIcon} className="ml-3" />
                ) : (
                  <AccordionIcon as={ChevronDownIcon} className="ml-3" />
                )}
              </>
            );
          }}
        </AccordionTrigger>
      </AccordionHeader>
      <AccordionContent>{props.children}</AccordionContent>
    </AccordionItem>
  );
});

SimpleAccordionItem.displayName = "SimpleAccordionItem";

export default SimpleAccordionItem;
